<template>
  <pull-to class="eds-approval-root" :style="{ height: height }" :top-load-method="onRefresh"
    @infinite-scroll="onAppend" :top-config="TOP_DEFAULT_CONFIG" :bottom-config="BOTTOM_DEFAULT_CONFIG">
    <v-tabs v-model="activeTabName">
      <v-tab href="#tabMyTask">{{ $t('我的任务') + '(' + myAwaitingTaskTotalCount + ')' }}</v-tab>
      <v-tab href="#tabMyApplication">{{ $t('我的申请') + '(' + myAwaitingApplicationTotalCount + ')' }}</v-tab>
    </v-tabs>
    <v-divider></v-divider>
    <v-tabs-items style="background-color: white" v-model="activeTabName">
      <v-tab-item value="tabMyTask">
        <eDSCompMyTaskList ref="refCompMyTaskList"></eDSCompMyTaskList>
      </v-tab-item>
      <v-tab-item value="tabMyApplication">
        <eDSCompMyApplicationList ref="refCompMyApplicationList"></eDSCompMyApplicationList>
      </v-tab-item>
    </v-tabs-items>
    <iDS-GoTop></iDS-GoTop>
  </pull-to>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import APP_CONFIG from '../../config/App'
import PullTo from 'vue-pull-to'
import iDSGoTop from '../../components/iDSGoTop'
import msgbus from '../../msgBus'
import eDSCompMyTaskList from '../../components/eDSCompMyTaskList'
import eDSCompMyApplicationList from '../../components/eDSCompMyApplicationList'

export default {
  name: 'eDSApproval',
  components: {
    PullTo,
    iDSGoTop,
    eDSCompMyTaskList,
    eDSCompMyApplicationList,
  },
  data() {
    return {
      TOP_DEFAULT_CONFIG: APP_CONFIG.tTOP_DEFAULT_CONFIG(),
      BOTTOM_DEFAULT_CONFIG: APP_CONFIG.tBOTTOM_DEFAULT_CONFIG(),
      activeTabName: '',
    }
  },
  computed: {
    height() {
      return `calc(${window.innerHeight}px - 48px` + ')'
    },
    myAwaitingTaskTotalCount() {
      return msgbus.vm.getUserAwaitingTaskTotalCount()
    },
    myAwaitingApplicationTotalCount() {
      return msgbus.vm.getUserAwaitingFlowTotalCount()
    },
  },
  methods: {
    // 刷新
    onRefresh(loaded) {
      if (this.activeTabName == 'tabMyTask') {
        this.$refs.refCompMyTaskList.onRefresh(loaded)
      } else {
        this.$refs.refCompMyApplicationList.onRefresh(loaded)
      }
    },

    // 翻页
    onAppend(loaded) {
      if (this.activeTabName == 'tabMyTask') {
        this.$refs.refCompMyTaskList.onAppend(loaded)
      } else {
        this.$refs.refCompMyApplicationList.onAppend(loaded)
      }
    },

    // 切换界面样式
    changeView() {
      msgbus.vm.setTitle(this.$t('审批'))
      msgbus.vm.setTitleVisible(true)
      msgbus.vm.setBackDisabled(false)
      msgbus.vm.setBackIcon('arrow_back')
      msgbus.vm.setBottomNavVisible(false)
      msgbus.vm.setBottomBtnVisible(false)
      msgbus.vm.setMsgInputVisible(false)
      msgbus.vm.setContentHeight({
        value: `calc(${window.innerHeight}px - 48px ` + ')',
      })
    },
    ...mapGetters('work', ['getWorkType']),
    ...mapMutations('work', ['setWorkType']),
  },
  created() {
    console.log('调试代码')
    if (msgbus.vm.getAccountToken() == null) {
      window.location.href = '/'
      return
    }

    // 读取路由参数：焦点页
    if (
      this.$route.params.activeTabName &&
      this.$route.params.activeTabName != ''
    ) {
      this.activeTabName = this.$route.params.activeTabName
    } else {
      this.activeTabName =
        this.getWorkType() != '' ? this.getWorkType() : 'tabMyTask'
    }

    // 读取用户审批中流程总数
    msgbus.vm
      .fetchUserAwaitingFlowsTotalCount({
        authorization: {
          Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
        },
        tid: msgbus.vm.getCurrentTenantID(),
        vm: msgbus.vm,
      })
      .then(
        () => { },
        () => { }
      )

    // 读取用户未审批任务总数
    msgbus.vm
      .fetchUserAwaitingTasksTotalCount({
        authorization: {
          Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
        },
        tid: msgbus.vm.getCurrentTenantID(),
        vm: msgbus.vm,
      })
      .then(
        () => { },
        () => { }
      )

    // 切换界面样式
    this.changeView()
  },
  mounted() { },
  beforeDestroy() {
    msgbus.vm.setMenuDisabled(true)
    msgbus.vm.setMenuItems([])
    msgbus.vm.setMenuIcon('')

    // 设置当前激活页
    this.setWorkType({ value: this.activeTabName })
  },
}
</script>

<style lang="scss">
.eds-approval-root {}
</style>
